/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ContentCategoriesPropertiesPanelComponent(
    this: JS5Object,
    _: JS5Object,
    CategoriesService: JS5Object,
    PermissionsService: JS5Object
) {
    const getData = () => {
        PermissionsService.isSystemOperator().then((isSystemOperator: boolean) => {
            this.canWriteLiveClipProps = isSystemOperator;
        });
        CategoriesService.getAllCategories().then((categories: JS5Object) => {
            this.shortFormCategoriesForLiveClips = _.filter(categories, (category: JS5Object) => {
                return _.isEqual(_.get(category, 'type.name'), 'Short Form');
            });
        });
    };

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };
}


angular.module('prism-ui.content').component('contentCategoriesPropertiesPanel', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/categoryPropertiesPanel/content-categories-properties-panel-template.html',
    controller: ContentCategoriesPropertiesPanelComponent,
    bindings: {
        editData: '<'
    }
});
